import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks/store-hooks';
import { clearComplianceAlert } from '../../application/states/dossie';
import { ComplianceAlertCard } from './ComplianceAlertCard';

export const ComplianceAlertContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const complianceAlert = useAppSelector((state) => state.dossie.complianceAlert);
  const currentResult = useAppSelector((state) => state.dossie.currentResult);

  if (!complianceAlert) return null;

  const handleClose = () => {
    dispatch(clearComplianceAlert());
    // Se estava na rota de resultado e não há dados carregados, volta para busca
    if (location.pathname.startsWith('/private/dossie/results') && !currentResult) {
      navigate('/private/dossie/search', { replace: true });
    }
  };

  return (
    <ComplianceAlertCard
      open={complianceAlert.open}
      onClose={handleClose}
      menorIdade={complianceAlert.menorIdade}
      pessoaRestrita={complianceAlert.pessoaRestrita}
      nome={complianceAlert.nome}
    />
  );
};
